<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4158 3.34702C12.8412 3.05099 12.1588 3.051 11.5842 3.34702L3.54208 7.48952C3.20919 7.66099 3 8.00406 3 8.37851V17.4663C3 18.2486 3.45611 18.959 4.16739 19.2847L12.0837 22.9094C12.348 23.0304 12.652 23.0304 12.9163 22.9094L20.8326 19.2847C21.5439 18.959 22 18.2486 22 17.4663V8.37851C22 8.00406 21.7908 7.66099 21.4579 7.48952L13.4158 3.34702ZM12.5 5.125L18.7135 8.32559L16.7161 9.24014L10.5228 6.14348L12.5 5.125ZM8.31997 7.27815L6.28651 8.32559L12.5 11.1706L14.3817 10.309L8.31997 7.27815ZM13.5 12.9124L20 9.93622V17.4663L13.5 20.4424V12.9124ZM11.5 12.9124V20.4424L5 17.4663V9.93622L11.5 12.9124Z"
      fill="currentColor"
    />
  </svg>
</template>
